/* Essential Set — Regular/Petite length, and the bundle builder.

   Ported from the 832-line custom-Liquid block that used to be this page's
   entire buy box. That block rendered its own swatches, size pills, sticky
   bar and gallery sync; all four now come from sm-main-product, so what
   survives here is only the part the theme genuinely cannot do: Petite is
   a different product, and nothing in Impulse's variant model can express
   that.

   Everything else defers to Impulse. We never write the form's variant id,
   never re-render an option, and never touch the gallery. In Regular mode
   this file is inert — the add to cart it intercepts is only intercepted
   while Petite is active.

   Cart adds reuse the old block's XHR-not-fetch approach on purpose: the
   store's cart and upsell apps hook XMLHttpRequest to detect an add and
   open their own drawer, and a fetch() slips past them.
*/
(function () {
  'use strict';

  var CHEVRON = '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL'];

  /* Option values here are plain colour and size names, but CSS.escape is
     the only thing that makes an attribute selector safe for whatever a
     merchant types into an option later. */
  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function idle(fn) {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
    else setTimeout(fn, 400);
  }

  /* Fire the events the store's cart and upsell apps listen for, so the app
     opens its own drawer. Deliberately does NOT click the theme's cart
     toggle — doing that opened two carts. */
  function notifyCartApps() {
    ['ajaxProduct:added', 'product:added', 'cart:refresh', 'cart:updated', 'cart:change', 'cart:build']
      .forEach(function (name) {
        try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: {} })); } catch (e) {}
      });
    if (window.Shopify && window.Shopify.onItemAdded) {
      try { window.Shopify.onItemAdded(); } catch (e) {}
    }
  }

  function submitItems(items, onDone, onFail) {
    if (!items || !items.length) return;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        notifyCartApps();
        if (onDone) onDone();
      } else {
        /* A 422 means the variant went out of stock between render and
           click. Falling through to /cart is the old block's behaviour and
           still the least confusing outcome. */
        if (onFail) onFail();
        window.location.href = '/cart';
      }
    };
    xhr.onerror = function () {
      if (onFail) onFail();
      window.location.href = '/cart';
    };
    xhr.send(JSON.stringify({ items: items }));
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ============================ Petite ============================ */

  function initPetite(section) {
    var group = section.querySelector('[data-sm-es-length-group]');
    if (!group) return;

    var data = parseJSON(group.querySelector('[data-sm-es-petite]'));
    if (!data || !data.variants) return;

    var btns      = group.querySelectorAll('[data-sm-es-length]');
    var valueEl   = group.querySelector('[data-sm-es-length-value]');
    var noteEl    = group.querySelector('[data-sm-es-length-note]');
    var colorWrap = section.querySelector('.variant-input-wrap[data-handle="color"]');
    var sizeWrap  = section.querySelector('.variant-input-wrap[data-handle="size"]');
    var atcBtn    = section.querySelector('[data-add-to-cart]');
    var priceEl   = section.querySelector('[data-product-price]');
    var form      = atcBtn ? atcBtn.closest('form') : null;
    if (!colorWrap || !sizeWrap || !atcBtn) return;

    /* Derived from the variant map rather than taken from the colours
       array, so the list can never disagree with the ids we are actually
       able to add. A colour counts as available in Petite only if some
       variant we hold exists for it. */
    var petiteColors = Object.keys(data.variants)
      .map(function (k) { return k.split('::')[0]; })
      .filter(function (c, i, a) { return a.indexOf(c) === i; });
    if (!petiteColors.length) petiteColors = data.colors || [];
    var messages = data.messages || {};
    var mode = 'regular';

    /* What Impulse last decided about each size label, captured before we
       overwrite it, so leaving Petite restores its answer rather than our
       guess at it. */
    var baseline = null;

    /* Impulse owns the label through [data-add-to-cart-text] and rewrites
       it on every variant change. Writing to that node instead of the
       button's innerHTML is what keeps its updates working — replacing the
       button's contents would delete the element it writes into, and it
       would silently stop updating from then on. */
    var atcTextEl = atcBtn.querySelector('[data-add-to-cart-text]') || atcBtn;
    var regularAtcText = atcTextEl.textContent;
    var regularAtcDisabled = atcBtn.disabled;
    var regularPriceHTML = priceEl ? priceEl.innerHTML : null;

    /* Impulse's answer for the current variant, captured on every variant
       change even while Petite is showing, so switching back to Regular
       restores the label for the variant selected *now* rather than the
       one selected before Petite was turned on. */
    function captureRegular() {
      regularAtcText = atcTextEl.textContent;
      regularAtcDisabled = atcBtn.disabled;
      if (priceEl) regularPriceHTML = priceEl.innerHTML;
    }

    function checkedIn(wrap) {
      return wrap.querySelector('input[data-variant-input]:checked');
    }
    function currentColor() {
      var i = checkedIn(colorWrap);
      return i ? i.value : null;
    }
    function currentSize() {
      var i = checkedIn(sizeWrap);
      return i ? i.value : null;
    }
    function isPetiteColor(name) {
      if (!name) return false;
      return petiteColors.indexOf(name) !== -1;
    }

    /* `mode` is a variable and the pill is what the shopper actually sees;
       if they ever disagree the shopper is right. Reading the pill back at
       submit time is what stops a Petite selection quietly adding a
       Regular set, which is exactly what a stale `mode` did. */
    function selectedMode() {
      var on = group.querySelector('[data-sm-es-length][aria-pressed="true"]');
      return on ? on.getAttribute('data-sm-es-length') : mode;
    }
    function petiteVariant(color, size) {
      return data.variants[color + '::' + size] || null;
    }
    function petiteAvailable(color, size) {
      var v = petiteVariant(color, size);
      return !!(v && v.available);
    }

    function showNote(html) {
      if (!noteEl) return;
      noteEl.innerHTML = html;
      noteEl.hidden = false;
    }
    function hideNote() {
      if (!noteEl) return;
      noteEl.hidden = true;
      noteEl.textContent = '';
    }

    function labelFor(input) {
      return input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL'
        ? input.nextElementSibling
        : null;
    }

    function snapshotSizes() {
      baseline = [];
      sizeWrap.querySelectorAll('input[data-variant-input]').forEach(function (input) {
        var label = labelFor(input);
        baseline.push({
          input: input,
          label: label,
          inputDisabled: input.classList.contains('disabled'),
          labelDisabled: label ? label.classList.contains('disabled') : false
        });
      });
    }

    function restoreSizes() {
      if (!baseline) return;
      baseline.forEach(function (rec) {
        rec.input.classList.toggle('disabled', rec.inputDisabled);
        if (rec.label) rec.label.classList.toggle('disabled', rec.labelDisabled);
      });
      baseline = null;
    }

    /* In Petite, availability comes from the Petite product, not this one. */
    function applyPetiteSizes() {
      var color = currentColor();
      sizeWrap.querySelectorAll('input[data-variant-input]').forEach(function (input) {
        var ok = petiteAvailable(color, input.value);
        var label = labelFor(input);
        input.classList.toggle('disabled', !ok);
        if (label) label.classList.toggle('disabled', !ok);
      });
    }

    function selectColorInput(name) {
      var input = colorWrap.querySelector('input[data-variant-input][value="' + cssEscape(name) + '"]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    function firstAvailablePetiteSize(color) {
      for (var i = 0; i < SIZE_ORDER.length; i++) {
        if (petiteAvailable(color, SIZE_ORDER[i])) return SIZE_ORDER[i];
      }
      return null;
    }

    function syncButtons() {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-sm-es-length') === mode;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (valueEl) {
        var active = group.querySelector('[data-sm-es-length="' + mode + '"]');
        if (active) valueEl.textContent = active.textContent.trim();
      }
    }

    function syncBuyButton() {
      if (mode !== 'petite') {
        atcTextEl.textContent = regularAtcText;
        atcBtn.disabled = regularAtcDisabled;
        if (priceEl && regularPriceHTML !== null) priceEl.innerHTML = regularPriceHTML;
        return;
      }
      var color = currentColor();
      var size = currentSize();
      var variant = petiteVariant(color, size);

      if (variant && variant.available) {
        atcBtn.disabled = false;
        atcTextEl.textContent = messages.addPetite || 'Add Petite Set';
      } else {
        atcBtn.disabled = true;
        atcTextEl.textContent =
          (messages.soldOutPetite || 'Petite [size] is sold out').replace('[size]', size || '');
      }
      if (priceEl && variant && typeof variant.price === 'number') {
        priceEl.innerHTML = formatMoney(variant.price);
      }
    }

    /* Express checkout can only carry this product's variants, so it can't
       represent a Petite selection at all. Hidden rather than disabled —
       a dead Shop Pay button invites a tap that silently does nothing. */
    function syncDynamicCheckout() {
      if (!form) return;
      form.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]')
        .forEach(function (el) { el.classList.toggle('sm-es-hidden', mode === 'petite'); });
    }

    /* The sticky bar mirrors the buy box; it re-reads each cloned pill's
       className from the label it was cloned from. Its own sync runs
       synchronously on variantChange while ours runs a frame later, and
       the Length pill fires no variantChange at all — so on this template
       it has to be nudged again afterwards or it shows stale Petite
       states. Reaches into _smSource/_smInput, which sexymodest-pdp.js
       sets on each clone. */
    function syncStickyMirror() {
      var bar = document.querySelector('[data-sm-sticky]');
      if (!bar) return;

      bar.querySelectorAll('[data-sm-sticky-pop] > *').forEach(function (clone) {
        if (!clone._smSource) return;
        clone.className = clone._smSource.className;
        if (clone._smInput && clone._smInput.checked) clone.classList.add('sm-is-selected');
      });

      var stickyAtc = bar.querySelector('[data-sm-sticky-atc]');
      var stickyAtcText = bar.querySelector('[data-sm-sticky-atc-text]');
      var stickyPrice = bar.querySelector('[data-sm-sticky-price]');
      if (stickyAtc) stickyAtc.disabled = atcBtn.disabled;
      if (stickyAtcText) stickyAtcText.textContent = atcTextEl.textContent;
      if (stickyPrice && priceEl) stickyPrice.innerHTML = priceEl.innerHTML;
    }


    /* The sticky bar ships with Color and Size chips built from the buy
       box's own option groups. Length isn't an option there, so the chip
       is added here rather than in sm-pdp-sticky-bar.liquid, which the
       standard product template shares and must not grow an Essential Set
       control.

       The chip reuses data-sm-sticky-toggle so the bar's own handler runs
       first and returns early - it has no popover registered under this
       kind - leaving the toggling below to do the work. */
    var stickyLength = null;

    function buildStickyLength() {
      var bar = document.querySelector('[data-sm-sticky]');
      if (!bar) return null;
      var row = bar.querySelector('.sm-pdp-sticky__row');
      var atc = bar.querySelector('[data-sm-sticky-atc]');
      if (!row || !atc || bar.querySelector('[data-sm-es-sticky-length]')) return null;

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'sm-pdp-sticky__chip';
      chip.setAttribute('data-sm-sticky-toggle', 'length');
      chip.setAttribute('data-sm-es-sticky-length', '');
      chip.setAttribute('aria-expanded', 'false');
      var label = document.createElement('span');
      chip.appendChild(label);
      chip.insertAdjacentHTML('beforeend', CHEVRON);
      row.insertBefore(chip, atc);

      var pop = document.createElement('div');
      pop.className = 'sm-pdp-sticky__pop sm-es-sticky__pop';
      pop.hidden = true;
      bar.appendChild(pop);

      var clones = [];
      btns.forEach(function (b) {
        var kind = b.getAttribute('data-sm-es-length');
        var c = document.createElement('button');
        c.type = 'button';
        c.className = 'sm-es-length__btn';
        c.textContent = b.textContent.trim();
        c.addEventListener('click', function () {
          setMode(kind);
          close();
        });
        clones.push({ el: c, kind: kind });
        pop.appendChild(c);
      });

      function close() {
        pop.hidden = true;
        chip.setAttribute('aria-expanded', 'false');
      }

      chip.addEventListener('click', function (evt) {
        evt.stopPropagation();
        bar.querySelectorAll('[data-sm-sticky-pop]').forEach(function (p) { p.hidden = true; });
        bar.querySelectorAll('[data-sm-sticky-toggle]').forEach(function (b) {
          if (b !== chip) b.setAttribute('aria-expanded', 'false');
        });
        var willOpen = pop.hidden;
        pop.hidden = !willOpen;
        chip.setAttribute('aria-expanded', String(willOpen));
      });

      bar.querySelectorAll('[data-sm-sticky-toggle]').forEach(function (b) {
        if (b !== chip) b.addEventListener('click', close);
      });
      document.addEventListener('click', function (evt) {
        if (!bar.contains(evt.target)) close();
      });
      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') close();
      });

      return { label: label, clones: clones };
    }

    function syncStickyLength() {
      if (!stickyLength) stickyLength = buildStickyLength();
      if (!stickyLength) return;
      var active = group.querySelector('[data-sm-es-length="' + mode + '"]');
      stickyLength.label.textContent = active ? active.textContent.trim() : '';
      stickyLength.clones.forEach(function (c) {
        c.el.classList.toggle('is-selected', c.kind === mode);
      });
    }

    function refresh() {
      /* First, so the pill always reflects the mode even when the size
         swap below returns early - selectedMode() reads it back at submit
         time and must never be looking at a stale attribute. */
      syncButtons();

      if (mode === 'petite') {
        if (!baseline) snapshotSizes();
        applyPetiteSizes();
        var color = currentColor();
        if (!petiteAvailable(color, currentSize())) {
          var next = firstAvailablePetiteSize(color);
          if (next) {
            var input = sizeWrap.querySelector('input[data-variant-input][value="' + cssEscape(next) + '"]');
            if (input && !input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              return; /* the resulting variantChange re-enters here */
            }
          }
        }
      } else {
        restoreSizes();
      }
      syncButtons();
      syncBuyButton();
      syncDynamicCheckout();
      syncStickyMirror();
      syncStickyLength();
      applyFormVariant();
    }

    function setMode(next) {
      if (next === mode) return;

      if (next === 'petite' && !isPetiteColor(currentColor())) {
        mode = 'petite';
        var fallback = petiteColors[0];
        if (fallback) {
          selectColorInput(fallback);
          showNote(messages.petiteForcesColor || '');
        }
      } else {
        mode = next;
        hideNote();
      }
      refresh();
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        setMode(b.getAttribute('data-sm-es-length'));
      });
    });

    /* Choosing a colour Petite doesn't carry drops back to Regular rather
       than blocking the tap — the colour the shopper asked for is the
       stronger signal, and the note says what happened. */
    section.addEventListener('variantChange', function () {
      requestAnimationFrame(function () {
        /* Only drop out of Petite for a colour we positively know it does
           not carry. currentColor() returns null while Impulse is midway
           through an update, and treating that as "not a Petite colour"
           silently reverted the mode with the pill left looking selected. */
        var colorNow = currentColor();
        if (mode === 'petite' && colorNow && !isPetiteColor(colorNow)) {
          mode = 'regular';
          restoreSizes();
          showNote(messages.colorLeavesPetite || '');
        }
        /* Impulse has just written its own answer for this variant.
           Capture it before refresh() paints Petite over the top. */
        captureRegular();
        refresh();
      });
    });

    /* The form carries the variant, so nothing here intercepts the click.

       Impulse posts new FormData(form) on submit, and the field it reads
       is a <select name="id"> holding this product's variants only - a
       Petite id cannot simply be assigned to it. So while Petite is
       selected the select is disabled, which takes it out of FormData
       entirely, and a hidden input of the same name carries the Petite id
       instead.

       Intercepting the click was the previous approach and it did not
       hold: preventDefault only wins if our listener actually runs first,
       and on this store something was adding the regular variant before
       it ever did. Putting the right id in the form removes the race - it
       does not matter who submits, or in what order, because there is
       only one id in there and it is the correct one. It also means the
       theme's own cart drawer and success handling apply for free. */
    var petiteIdInput = null;

    function applyFormVariant() {
      if (!form) return;
      var select = form.querySelector('select[name="id"], [data-product-select]');

      if (selectedMode() !== 'petite') {
        if (petiteIdInput) {
          petiteIdInput.parentNode.removeChild(petiteIdInput);
          petiteIdInput = null;
        }
        if (select) select.disabled = false;
        return;
      }

      var variant = petiteVariant(currentColor(), currentSize());

      if (!petiteIdInput) {
        petiteIdInput = document.createElement('input');
        petiteIdInput.type = 'hidden';
        petiteIdInput.name = 'id';
        petiteIdInput.setAttribute('data-sm-es-id', '');
        form.appendChild(petiteIdInput);
      }
      /* Empty rather than absent when Petite has no such variant: an
         empty id fails the add outright, where removing it would let the
         select come back and quietly add the Regular one. */
      petiteIdInput.value = variant && variant.available ? String(variant.id) : '';
      if (select) select.disabled = true;
    }

    /* Impulse rewrites the select on every variant change, and an app may
       submit without one. Re-asserting on the way into a submit costs
       nothing and closes the gap; note it never cancels the event. */
    atcBtn.addEventListener('click', applyFormVariant, true);
    if (form) form.addEventListener('submit', applyFormVariant, true);

    /* Rendered availability can be minutes stale behind Shopify's page
       cache; stock can't be. */
    idle(function () {
      fetch('/products/' + (data.handle || 'petite-essential-set') + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          (p.variants || []).forEach(function (v) {
            var key = v.option1 + '::' + (v.option2 || '');
            if (data.variants[key]) {
              data.variants[key].available = v.available;
              data.variants[key].price = v.price;
            }
          });
          refresh();
        })
        .catch(function () {});
    });

    refresh();
  }

  /* ========================= Size chart ========================= */

  function initSizeChart(section) {
    var root = section.querySelector('[data-sm-es-sc]');
    if (!root) return;

    var openBtn = root.querySelector('[data-sm-es-sc-open]');
    var modal   = root.querySelector('[data-sm-es-sc-modal]');
    var card    = root.querySelector('[data-sm-es-sc-card]');
    var closeEl = root.querySelector('[data-sm-es-sc-close]');
    if (!openBtn || !modal) return;

    function open() {
      modal.hidden = false;
      /* Next frame, so the transition has a from-state to animate out of. */
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sm-es-locked');
      if (closeEl) closeEl.focus();
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sm-es-locked');
      setTimeout(function () { modal.hidden = true; }, 200);
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeEl) closeEl.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (card && !card.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* =========================== Bundle =========================== */

  function initBundle(section) {
    var root = section.querySelector('[data-sm-es-bundle]');
    if (!root) return;

    var data = parseJSON(root.querySelector('[data-sm-es-bundle-data]'));
    if (!data || !data.variants) return;

    /* Petite ids live with the length control; the bundle borrows them so
       a bundle row can be Petite. Absent block means Regular-only rows. */
    var petite = parseJSON(section.querySelector('[data-sm-es-petite]'));
    var petiteColors = petite && petite.colors ? petite.colors : [];
    var petiteVariants = petite && petite.variants ? petite.variants : {};

    var modal   = section.querySelector('[data-sm-es-bundle-modal]');
    var card    = section.querySelector('[data-sm-es-bundle-card]');
    var closeEl = section.querySelector('[data-sm-es-bundle-close]');
    var subEl   = section.querySelector('[data-sm-es-bundle-sub]');
    var setsEl  = section.querySelector('[data-sm-es-bundle-sets]');
    var addBtn  = section.querySelector('[data-sm-es-bundle-add]');
    if (!modal || !setsEl || !addBtn) return;

    var colorWrap = section.querySelector('.variant-input-wrap[data-handle="color"]');
    var sizeWrap  = section.querySelector('.variant-input-wrap[data-handle="size"]');
    var sizes = data.sizes || SIZE_ORDER;

    var state = { tier: 0, sets: [] };

    function avail(set, size) {
      var key = set.color + '::' + size;
      if (set.length === 'petite') {
        var pv = petiteVariants[key];
        return !!(pv && pv.available);
      }
      var v = data.variants[key];
      return !!(v && v.available);
    }
    function variantId(set) {
      var key = set.color + '::' + set.size;
      var v = set.length === 'petite' ? petiteVariants[key] : data.variants[key];
      return v ? v.id : null;
    }
    function colorsFor(set) {
      return set.length === 'petite' ? petiteColors : (data.colors || []);
    }

    function option(value, text, disabled) {
      var o = document.createElement('option');
      o.value = value;
      o.textContent = text;
      if (disabled) o.disabled = true;
      return o;
    }

    function fillColors(sel, set) {
      var list = colorsFor(set);
      if (list.indexOf(set.color) === -1) set.color = list[0];
      sel.textContent = '';
      list.forEach(function (c) { sel.appendChild(option(c, c, false)); });
      sel.value = set.color;
    }

    function fillSizes(sel, set) {
      var firstAvail = null;
      sel.textContent = '';
      sizes.forEach(function (sz) {
        var ok = avail(set, sz);
        if (ok && firstAvail === null) firstAvail = sz;
        sel.appendChild(option(sz, ok ? sz : sz + ' — sold out', !ok));
      });
      if (!avail(set, set.size) && firstAvail) set.size = firstAvail;
      sel.value = set.size;
    }

    function renderSets() {
      setsEl.textContent = '';
      state.sets.forEach(function (set, idx) {
        var row = document.createElement('div');
        row.className = 'sm-es-bundle__set';

        var label = document.createElement('span');
        label.className = 'sm-es-bundle__set-label';
        label.textContent = 'Set ' + (idx + 1);

        var csel = document.createElement('select');
        csel.className = 'sm-es-bundle__sel';
        csel.setAttribute('aria-label', 'Set ' + (idx + 1) + ' color');

        var ssel = document.createElement('select');
        ssel.className = 'sm-es-bundle__sel sm-es-bundle__sel--size';
        ssel.setAttribute('aria-label', 'Set ' + (idx + 1) + ' size');

        var lsel = document.createElement('select');
        lsel.className = 'sm-es-bundle__sel sm-es-bundle__sel--len';
        lsel.setAttribute('aria-label', 'Set ' + (idx + 1) + ' length');
        lsel.appendChild(option('regular', 'Regular', false));
        if (petiteColors.length) lsel.appendChild(option('petite', 'Petite', false));
        lsel.value = set.length;

        csel.addEventListener('change', function () {
          set.color = csel.value;
          fillSizes(ssel, set);
        });
        ssel.addEventListener('change', function () { set.size = ssel.value; });
        lsel.addEventListener('change', function () {
          set.length = lsel.value;
          fillColors(csel, set);  /* Petite may not carry the current colour */
          fillSizes(ssel, set);
        });

        fillColors(csel, set);
        fillSizes(ssel, set);

        row.appendChild(label);
        row.appendChild(csel);
        row.appendChild(ssel);
        row.appendChild(lsel);
        setsEl.appendChild(row);
      });
    }

    function renderAdd(tier) {
      var meta = (data.tiers || {})[String(tier)] || {};
      addBtn.textContent = '';
      var main = document.createElement('span');
      main.className = 'sm-es-bundle__add-main';
      main.textContent = meta.add || 'Add bundle';
      var pill = document.createElement('span');
      pill.className = 'sm-es-bundle__save';
      pill.textContent = meta.save || '';
      addBtn.appendChild(main);
      if (meta.save) addBtn.appendChild(pill);
    }

    function currentSelection() {
      var c = colorWrap ? colorWrap.querySelector('input[data-variant-input]:checked') : null;
      var s = sizeWrap ? sizeWrap.querySelector('input[data-variant-input]:checked') : null;
      return {
        color: c ? c.value : (data.colors || [])[0],
        size: s ? s.value : sizes[0]
      };
    }

    function open(tier) {
      var sel = currentSelection();
      state.tier = tier;
      state.sets = [];
      for (var i = 0; i < tier; i++) {
        state.sets.push({ color: sel.color, size: sel.size, length: 'regular' });
      }
      var meta = (data.tiers || {})[String(tier)] || {};
      if (subEl) subEl.textContent = meta.sub || '';
      renderAdd(tier);
      addBtn.disabled = false;
      renderSets();
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sm-es-locked');
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sm-es-locked');
      setTimeout(function () { modal.hidden = true; }, 200);
    }

    root.querySelectorAll('[data-sm-es-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(parseInt(btn.getAttribute('data-sm-es-tier'), 10));
      });
    });
    if (closeEl) closeEl.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (card && !card.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    addBtn.addEventListener('click', function () {
      /* Block a sold-out row rather than letting /cart/add.js 422 and
         bounce the shopper to the cart page. */
      var soldOut = state.sets.some(function (s) { return !avail(s, s.size); });
      if (soldOut) {
        addBtn.textContent = 'A set is sold out — pick another';
        setTimeout(function () { renderAdd(state.tier); }, 2200);
        return;
      }

      var qty = {};
      state.sets.forEach(function (s) {
        var v = variantId(s);
        if (v) qty[v] = (qty[v] || 0) + 1;
      });
      var items = Object.keys(qty).map(function (v) {
        return { id: parseInt(v, 10), quantity: qty[v] };
      });
      if (!items.length) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      submitItems(items, function () {
        addBtn.disabled = false;
        close();
      }, function () {
        addBtn.disabled = false;
        renderAdd(state.tier);
      });
    });
  }

  /* ========================== Sold recently ========================= */

  /* One count per page load, shared by every node that asks for it, so the
     buy box and the bundle widgets can never show different numbers. */
  function initScarcity(section) {
    var hosts = section.querySelectorAll('[data-sm-es-scarcity]');
    if (!hosts.length) return;

    var first = hosts[0];
    var min = parseInt(first.getAttribute('data-min'), 10);
    var max = parseInt(first.getAttribute('data-max'), 10);
    if (isNaN(min)) min = 100;
    if (isNaN(max)) max = 200;
    if (max < min) max = min;

    var count = min + Math.floor(Math.random() * (max - min + 1));

    hosts.forEach(function (host) {
      var n = host.querySelector('[data-sm-es-scarcity-n]');
      if (n) n.textContent = count;
      host.hidden = false;
    });
  }

  /* ============================ Boot ============================ */

  function init(section) {
    if (section.smEsReady) return;
    section.smEsReady = true;
    initPetite(section);
    initSizeChart(section);
    initBundle(section);
    initScarcity(section);
  }

  function boot() {
    document.querySelectorAll('[data-sm-es]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('[data-sm-es]');
    if (el) init(el);
  });
})();
